// extracted by mini-css-extract-plugin
export default {"page":"Print_page__Wfzwm","break":"Print_break__rw69M"};